export function toNumberIfNumeric (value) {
  return isNaN(value) || value === '' ? value : Number(value)
}
